import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { DeliveryOrderDriverStatus } from './delivery-order-driver-status';
import { Dto } from '@core/data/dto/dto';
import { DeliveryOrderDriverSchema } from './delivery-order-driver.schema';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';

@DtoForceConstructor
export class DeliveryOrderDriver {
    public id: string;
    public companyId: string;
    public locationId: string;
    public latitude: number;
    public longitude: number;
    public name: string;
    public status: DeliveryOrderDriverStatus;
    public avatarUrl: string;
    public polyline: string;

    public orders?: { [key: string]: string };

    @DtoImport(DeliveryOrderDriverSchema)
    static import(dto: Dto): any {}

    constructor(value?: {
        id: string;
        companyId: string;
        locationId: string;
        latitude: number;
        longitude: number;
        name: string;
        status: DeliveryOrderDriverStatus;
        avatarUrl: string;
        polyline: string;
    }) {
        if (value) {
            this.id = value.id;
            this.companyId = value.companyId;
            this.locationId = value.locationId;
            this.latitude = value.latitude;
            this.longitude = value.longitude;
            this.name = value.name;
            this.status = value.status;
            this.avatarUrl = value.avatarUrl;
            this.polyline = value.polyline;
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderDriverSchema,
        },
    ])
    export(type?: DtoType): any {}
}
